module.exports = __webpack_public_path__ + "img/GH.f3829446.svg";